export default "__VITE_ASSET__OQoMb3aE__";